import React from "react"
import Dashboard from "../components/Dashboard"
import style from '../style/home.module.css'
import { useData } from "../function/method_desp_rec";
import Saldo from "../components/Saldo";

export default function Home(){

    const {listaGastos} = useData()

    const {listaReceitas} = useData()


    return(
        <>
        <Saldo mostraOpcao={true}/>
        <main className={style.dashboards}>
            <Dashboard
                conteudo="Lista de Gastos"
                list={listaGastos}
                comMes={true}
                listaVaziaDe="Despesa"
                colocarFiltroParaLista={true}
            />
            
            <Dashboard
                conteudo="Lista de Receita"
                list={listaReceitas || []}
                comMes={false}
                listaVaziaDe="Receita"
                colocarFiltroParaLista={false}
            />
        </main>
        </>
    )
}